import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  apiSetStore: (bvModal, id, params, callback) => {
    return AppModel.get('projects/detail/' + id, bvModal, params, (res) => {
      if (isDebug) {
        console.log(res.data)
      }

      AppModel.validateStatus(res.data)

      let modelStore = store.getters.model
      if (!modelStore) {
        modelStore = {}
      }
      modelStore['projectDetail'] = res.data
      store.commit('setModel', modelStore)

      return Promise.resolve(res.data)
    }, null, callback)
  },
  getStore: (key) => {
    return AppModel.getStore('projectDetail', key)
  },
  removeStore: () => {
    delete store.getters.model.projectDetail
  }
}



// WEBPACK FOOTER //
// ./src/models/ProjectDetailModel.js